export const APP_ROUTE_PREFIXES = ['/dashboard', '/users', '/authentication', '/settings'] as const;

const STATIC_EXPORT_BASE_URL = 'https://eezi.invalid';

const serializeLocalUrl = (url: URL): string => `${url.pathname}${url.search}${url.hash}`;

export const getStaticExportRedirectPath = (path: string | string[] | undefined): string | null => {
  const rawPath = Array.isArray(path) ? path[0] : path;

  if (!rawPath) {
    return null;
  }

  let decodedPath = rawPath;

  try {
    decodedPath = decodeURIComponent(rawPath);
  } catch {
    decodedPath = rawPath;
  }

  const normalizedPath = `/${decodedPath.replace(/^\/+/, '')}`;

  try {
    const url = new URL(normalizedPath, STATIC_EXPORT_BASE_URL);
    if (url.searchParams.get('loop') === 'true') return '/404/';

    return serializeLocalUrl(url);
  } catch {
    return normalizedPath;
  }
};

export const getStaticExportRedirectTarget = (path: string): string => {
  if (path === '/404/') return path;

  const url = new URL(path, STATIC_EXPORT_BASE_URL);
  url.searchParams.set('loop', 'true');
  return serializeLocalUrl(url);
};

export const isAppRoutePath = (path: string | null): boolean => {
  if (!path) return false;

  try {
    const { pathname } = new URL(path, STATIC_EXPORT_BASE_URL);
    return APP_ROUTE_PREFIXES.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`));
  } catch {
    return false;
  }
};
